var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{attrs:{"current-view":"Home"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"my-5 my-lg-0"},[_c('performedWork-details')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }